import script from "./ModuleType404.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleType404.vue?vue&type=script&setup=true&lang=js"

import "./ModuleType404.vue?vue&type=style&index=0&id=d10f4082&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10f4082"]])

export default __exports__